import React from 'react';

import { Messages } from '../../codegen/Localize';
import { imgPath } from '../../common/utilities/ImgUrl';
import { SiteRoles } from '../../ts/ServerApi/types/ISiteRole';
import { LearnTableauStyles } from '../styles/LearnTableauStyles';
import { HelpService } from '../../commonInfra/services/HelpService';

const ARROW_ICON: string = imgPath('arrow_style1_right.svg');

export interface LearnTableauChannelProps {
  userSiteRole: string;
}

export class LearnTableauChannel extends React.PureComponent<LearnTableauChannelProps> {
  private locale: string;
  private queryParams: string;

  constructor(props: LearnTableauChannelProps) {
    super(props);
    this.locale = HelpService.helpUrlLanguage();
    this.queryParams = HelpService.getQueryParams();
  }

  private getUserRoleUrl(userSiteRole: string) {
    let roleBasedUrl = '';
    switch (this.props.userSiteRole){
      case SiteRoles.Creator: {
        roleBasedUrl = LearnTableauUrlSegments.learnTableauLinkCreator;
        break;
      }
      case SiteRoles.ExplorerCanPublish:
      case SiteRoles.Explorer: {
        roleBasedUrl = LearnTableauUrlSegments.learnTableauLinkExplorer;
        break;
      }
      case SiteRoles.SiteAdministratorExplorer: {
        roleBasedUrl = LearnTableauUrlSegments.learnTableauLinkAdminExplorer;
        break;
      }
      case SiteRoles.ViewerWithPublish:
      case SiteRoles.Viewer: {
        roleBasedUrl = LearnTableauUrlSegments.learnTableauLinkViewer;
        break;
      }
      case SiteRoles.Guest:
      case SiteRoles.ServerAdministrator:
      case SiteRoles.SiteAdministratorCreator:
      case SiteRoles.SupportUser:
      case SiteRoles.Unlicensed:
      case SiteRoles.UnlicensedWithPublish:
      default: {
        roleBasedUrl = LearnTableauUrlSegments.learnTableauLinkAdminCreator;
      }
    }
    return roleBasedUrl;
  }

  render() {
    const roleBasedUrl = this.getUserRoleUrl(this.props.userSiteRole);
    return (
      <section className= {LearnTableauStyles.banner}>
        <p className= {LearnTableauStyles.text}> {Messages.home_learnTableau_LearnTableau()} <LearnTableauLink
        url={`https://www.tableau.com/${this.locale}/app/${roleBasedUrl}?${this.queryParams}`}
        linkTitle= {Messages.home_learnTableau_FreeTrainingVideos()} /> </p>
      </section>
    );
  }
}

export interface LearnTableauLinkProps {
  linkTitle: string;
  url: string;
}

export class LearnTableauLink extends React.PureComponent<LearnTableauLinkProps> {
  render() {
    return (
      <a className={LearnTableauStyles.link}
        href={this.props.url}
        target= {'_blank'}
        rel={'noopener noreferrer'}
        data-tb-test-id={LearnTableauTestIds.learnTableauLink}
      >
      {Messages.home_learnTableau_FreeTrainingVideos()}&nbsp;&nbsp;<img className={LearnTableauStyles.arrow} src={ARROW_ICON} alt={Messages.home_learnTableau_RightArrow()} />
      </a>
    );
  }
}

export namespace LearnTableauTestIds {
  export const learnTableauLink = 'learn-tableau-link';
}

export namespace LearnTableauUrlSegments {
  export const learnTableauLinkAdminExplorer = 'server-home-adexplore';
  export const learnTableauLinkExplorer = 'server-home-explorer';
  export const learnTableauLinkViewer = 'server-home-viewer';
  export const learnTableauLinkCreator = 'server-home-creator';
  export const learnTableauLinkAdminCreator = 'server-home-adcreator';
}
